module.exports = __webpack_public_path__ + "img/gather_predictive_data.c241b266.svg";